import { request } from '@/utils/request/request';

export function ele3(query) {
  return request({
    url: 'api/tongji/v1/GetYongDianLiangForBYQ',
    // url: 'api/guangfu/v1/GetYongDianLiangForBYQ',
    method: 'get',
    params: query,
  });
}
// 用电概况（本月上月用电量柱状图数据接口）
export function ele4(query) {
  return request({
    // url: '/api/guangfu/v1/GetQiYeZongYongDianLiang',
    url: '/api/tongji/v1/GetQiYeZongYongDianLiang',
    method: 'get',
    params: query,
  });
}
